import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import ProfileComment from './profile-comment-model'
import {
  CreateProfileCommentAsync,
  DeleteProfileCommentAsync,
  LoadProfileCommentsAsync,
} from './profileComment-thunk'
const initialState: profileCommentSliceState = {
  profileComment: [],
  selected_profileComment: '',
  is_loading_profileComment: false,
  is_creating_profileComment: false,
  is_deleting_profileComment: false,
}
export interface profileCommentSliceState {
  profileComment: ProfileComment[]
  selected_profileComment?: string
  is_loading_profileComment: boolean
  is_creating_profileComment: boolean
  is_deleting_profileComment: boolean
}
export const profileCommentSlice = createSlice({
  name: 'profileComment',
  initialState,
  reducers: {
    setSelectedprofileComment: (state, action) => {
      state.selected_profileComment = action.payload
    },
    clearStateprofileComment: (state) => {
      state.profileComment = []
      state.is_loading_profileComment = false
      state.is_creating_profileComment = false
      state.is_deleting_profileComment = false
    },
    mergeprofileComment: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_profileComment = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.profileComment = merge(state.profileComment, payload) as any
        }
      }
    },

    add_profileComment: (state, action) => {
      if (action.payload) {
        state.profileComment = [...state.profileComment, action.payload]
      }
    },
    set_profileComment: (state, action) => {
      let { key, value, id } = action.payload
      state.profileComment = state.profileComment.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadProfileCommentsAsync.pending, (state) => {
      state.is_loading_profileComment = true
    })
    builder.addCase(LoadProfileCommentsAsync.fulfilled, (state, action) => {
      state.is_loading_profileComment = false
      if (action.payload) {
        state.profileComment = action.payload
      }
    })
    builder.addCase(LoadProfileCommentsAsync.rejected, (state) => {
      state.is_loading_profileComment = false
    })
    builder.addCase(CreateProfileCommentAsync.pending, (state) => {
      state.is_creating_profileComment = true
    })
    builder.addCase(CreateProfileCommentAsync.fulfilled, (state) => {
      state.is_creating_profileComment = false
    })
    builder.addCase(CreateProfileCommentAsync.rejected, (state) => {
      state.is_creating_profileComment = false
    })
    builder.addCase(DeleteProfileCommentAsync.pending, (state) => {
      state.is_deleting_profileComment = true
    })
    builder.addCase(DeleteProfileCommentAsync.fulfilled, (state, action) => {
      state.is_deleting_profileComment = false
      if (state.profileComment) {
        state.profileComment = state.profileComment.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteProfileCommentAsync.rejected, (state) => {
      state.is_deleting_profileComment = false
    })
  },
})

export const {
  clearStateprofileComment,
  setSelectedprofileComment,
  set_profileComment,
  mergeprofileComment,
  add_profileComment,
} = profileCommentSlice.actions

export const get_profileComment =
  (id?: string) =>
  (state: {
    profileComment: {
      profileComment: ProfileComment[]
    }
  }): ProfileComment | null => {
    let temp = state?.profileComment?.profileComment?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.profileComment?.profileComment[0] || null
  }
export const get_selected_profileComment = (state: {
  profileComment: profileCommentSliceState
}): ProfileComment | null => {
  let id = state?.profileComment?.selected_profileComment
  let temp = state?.profileComment?.profileComment?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_profileComment = (state: {
  profileComment: {
    profileComment: ProfileComment[]
  }
}): ProfileComment[] => {
  let temp = state?.profileComment?.profileComment
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_profileComment_busy = (state: {
  profileComment: profileCommentSliceState
}) => {
  return (
    state?.profileComment.is_deleting_profileComment ||
    state?.profileComment.is_loading_profileComment ||
    state?.profileComment.is_creating_profileComment
  )
}
export const is_deleting_profileComment_busy = (state: {
  profileComment: profileCommentSliceState
}) => {
  return state?.profileComment.is_deleting_profileComment
}
export const is_loading_profileComment_busy = (state: {
  profileComment: profileCommentSliceState
}) => {
  return state?.profileComment.is_loading_profileComment
}
export const is_creating_profileComment_busy = (state: {
  profileComment: profileCommentSliceState
}) => {
  return state?.profileComment.is_creating_profileComment
}

export default profileCommentSlice.reducer
